import urlParser from 'url';

/**
 * @param audioBlob
 * @param domain
 * @param format
 * @param greetingName
 * @param id
 * @param index
 * @param language
 * @param name
 * @param owner
 * @param ownerDomain
 * @param sourceType
 * @param script
 * @param type
 * @param user
 * @param voiceId
 * @returns {Promise<void>}
 */
export default async ({
  audioBlob,
  domain,
  format,
  greetingName,
  id,
  index,
  name,
  owner,
  ownerDomain,
  sourceType,
  script,
  type,
  user,
  voiceId,
  voiceLanguage,
}) => {
  const token = global.localStorage.getItem('ns_t');

  if (!token) {
    throw Error('authenticate function requires a netsapiens local storage user token');
  }

  const { protocol, hostname } = urlParser.parse(global.location.href);

  let url = `${protocol}//${hostname}/ns-api/`;
  url += '?object=audio';
  url += '&action=upload';
  url += '&convert=yes';
  url += `&format=${format}`;
  url += `&index=${index}`;
  url += `&script=${script}`;
  url += `&moh_script=${script}`;
  url += `&type=${type}`;

  if (domain) url += `&domain=${domain}`;
  if (greetingName) url += `&greeting_name=${greetingName}`;
  if (id) url += `&id=${id}`;
  if (owner) url += `&owner=${owner}`;
  if (ownerDomain) url += `&owner_domain=${ownerDomain}`;
  if (name) url += `&name=${name}`;
  if (user) url += `&user=${user}`;
  if (sourceType) url += `&source_type=${sourceType}`;
  if (voiceId) url += `&voice_id=${voiceId}`;
  if (voiceLanguage) url += `&voice_language=${voiceLanguage}`;

  await new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    const request = new XMLHttpRequest();
    request.open('POST', url);
    request.setRequestHeader('Authorization', `Bearer ${token}`);
    request.onreadystatechange = () => {
      if (request.readyState === 4
        && (request.status === 200 || request.status === 202)
      ) {
        resolve();
      } else if (request.readyState === 4) {
        reject();
      }
    };

    // eslint-disable-next-line no-undef
    const formData = new FormData();
    formData.append('file', audioBlob);
    formData.append('format', format);
    request.send(formData);
  });
};
